import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiCall } from '@shared/async-services/http/api-call.service';
import { BroadCastServiceService } from '@shared/services/broad-cast-service.service';
import storageService from '@shared/storage/storageService';
import { ToastrService } from 'ngx-toastr';
import { startWith, map } from 'rxjs/operators';
import { MultiSelectComponent } from '@syncfusion/ej2-angular-dropdowns';
import { CheckBoxComponent } from '@syncfusion/ej2-angular-buttons';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-edit-accuser',
  templateUrl: './edit-accuser.component.html',
  styleUrls: ['./edit-accuser.component.scss']
})


export class EditAccuserComponent implements OnInit {
  public userForm: FormGroup;
  public roles: FormArray;
  public submitted = false;
  currentUser:any;
  loading: boolean =false;
  data: any[];
  userRoles : any;
  selectedRole;
  organizationList: any;
  selectedOrg = '';
  accountants: any[];
  userId :any;
  updateToaster :any;
  assignToaster :any;
  isRole = false;
  isAssignedAccountant = false;
  roleToUpdate : any;
  arrayOfRecepients = [];


  @ViewChild('checkbox')
  public mulObj: MultiSelectComponent;
  @ViewChild('selectall')
  public checkboxObj: CheckBoxComponent;
  @ViewChild('dropdown')
  public dropdownObj: CheckBoxComponent;
  @ViewChild('select')
  public reorderObj: CheckBoxComponent;
  public mode: string;
  public filterPlaceholder: string;
  public selectedAccountants: any = [];
  public accountantId : any;

  

  public checkFields: Object = { text: 'name', value: 'accountantId' };
  public checkWaterMark: string = 'Select Accountants';
  public popHeight: string = '350px';
  
  constructor(public dialogRef: MatDialogRef<EditAccuserComponent>,
    public fb: FormBuilder, public auth: ApiCall,
    private toastr: ToastrService,
    private broadCast: BroadCastServiceService,
    public translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public editData: any) { }

  ngOnInit(): void {
    this.mode = 'CheckBox';
    this.filterPlaceholder = 'Search accountants';
    this.selectedAccountants = [];

    this.currentUser = storageService.getItemAsJSON("currentUser");
    this.getAccountants();
    this.getOrganisationList(); 
    this.getUserRoles();
    this.userForm = this.fb.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      email: ['', [Validators.required]],
      contactNumber: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      roles: [''],
      organizationId: [''],
      assignAccountants: ['',[Validators.required]],
      useCompanyAddress : this.editData.useCompanyAddress ? this.editData.useCompanyAddress : true,
      city : [''],
      activitySector : [''],
      activity : [''],
      turnover : [''],
      effective : [''],
      clientOrganization:['']
    });

    this.userForm.patchValue({
      firstName: this.editData.firstName,
      lastName: this.editData.lastName,
      email: this.editData.email,
      contactNumber: this.editData.contactNumber,
      roles:this.editData.roles[0].id,
      organizationId: this.editData.organizationId,
      assignAccountants : this.selectedAccountants,
      city: this.editData.city,
      activitySector : this.editData.activitySector,
      activity : this.editData.activity,
      turnover : this.editData.turnover,
      effective : this.editData.effective,
      clientOrganization: this.editData.clientOrganization
    });
    this.selectedRole = this.editData.roles[0].id;
    this.selectedOrg = this.editData.organizationId;
    this.userForm.get('email').valueChanges.subscribe((event) => {
      this.userForm.get('email').setValue(event.toLowerCase(), { emitEvent: false });
      })

    this.getAssignAccountant(); 
  }

  getAssignAccountant(){
    this.auth.getUserAccountants(this.editData.id).subscribe((res: any) => {
      try {
        let accountantList = res.data;
        accountantList.forEach(accountant => {
          if (accountant != null) {
            this.selectedAccountants.push(accountant.accountantId);
          }
        });
        this.userForm.setValue({
          assignAccountants : this.selectedAccountants
        });
      } catch(e) {
        console.log("Error while assigning accountants :: ",e);
      }
    });
  }
  select(event){
    // console.log("Event",event.itemData.id);
  }

  onRemove(event){
    try {
      this.auth.deleteAssignAccountantToClient(this.editData.id,event.itemData.id).subscribe((res:any)=>{
        if(res.status == "SUCCESS"){
          this.translate.get(['ACCOUNTANT.USERS.ADD_USER.DELETE_SUCCESS'])
          .subscribe(translations => {
            this.updateToaster = translations['ACCOUNTANT.USERS.ADD_USER.DELETE_SUCCESS'];
          });
       this.toastr.success(this.updateToaster,'');

        }else{
          this.translate.get(['ACCOUNTANT.USERS.ADD_USER.DELETE_FAIL'])
          .subscribe(translations => {
            this.updateToaster = translations['ACCOUNTANT.USERS.ADD_USER.DELETE_FAIL'];
          });
          this.toastr.error(this.updateToaster,'');
        }
       
      });
    } catch (error) {
      console.log("Error")
    }
  }

  selectionChange(event) {
    // let ejs = document.getElementById('multiselect-checkbox')
    // if(ejs) {
    //   let data = ejs.getElementsByClassName('e-multi-select-wrapper')[0]
    //   if(data) {
    //     if(!this.userForm.get('assignAccountants').errors) {
    //       data.classList.remove('border-error')
    //     }
    //   }
    // }
    this.isAssignedAccountant= true;
  }
  getOrganisationList() {
    this.auth.getOrganisationList().subscribe((res: any) => {
      this.data = res.data;
      this.organizationList = this.data[0];
    })
  }

  get f(): { [key: string]: AbstractControl } {
    return this.userForm.controls;
  }

  getUserRoles() {
    this.auth.getUserRoles().subscribe((res: any) => {
      this.userRoles = res.data;
    })
  }

  getRole(obj) {
    let temp = [];
    let role_object = this.userRoles.find(role=> role.id == obj );
    temp.push(role_object);
    return temp;
  }

  changeRole(evt){
    this.selectedRole=evt.target.value;
    this.isRole = true;
  }
  cancel(): void {
    this.dialogRef.close(false);
  }

  updateData(): void {
    try {
      this.submitted = true;
      // let ejs = document.getElementById('multiselect-checkbox')
      // if(ejs) {
      //   let data = ejs.getElementsByClassName('e-multi-select-wrapper')[0]
      //   if(data) {
      //     if(this.userForm.get('assignAccountants').errors) {
      //       data.classList.add('border-error')
      //     }
      //   }
      // }
      if (!this.userForm.valid) {
        return;
      }
        this.updateUser();
    } catch {
      this.toastr.error(this.updateToaster, '');
    }
  }
  alphabetKeyPress(event: any) {
    const inputField = event.target as HTMLInputElement;
    const pattern = /^[a-zA-Z\s!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~ ]*$/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  
  assignAccountants(assignAccountants){
    if (assignAccountants.length > 0) {
      let accountantObj = this.preparedAssignAccountantRequestObject(assignAccountants);
      this.auth.assignAccountants(this.userId, accountantObj).subscribe((response) => {
        this.dialogRef.close(false);
        this.assignToaster=response.message;
        this.translate.get(['ACCOUNTANT.USERS.ADD_USER.ASSIGN_SUCCESS'])
        .subscribe(translations => {
          this.updateToaster = translations['ACCOUNTANT.USERS.ADD_USER.ASSIGN_SUCCESS'];
        });
     this.toastr.success(this.updateToaster,'');
      this.broadCast.sendMessage('getClientUsers');
      this.broadCast.sendMessage('accountant-dashboard'); 
      }, (err) => {
        this.toastr.error(this.assignToaster, 'fail');
      });
    } else {
      this.translate.get(['ACCOUNTANT.USERS.ADD_USER.ASSIGN_FAIL'])
        .subscribe(translations => {
          this.updateToaster = translations['ACCOUNTANT.USERS.ADD_USER.ASSIGN_FAIL'];
        });
    }
  }
  onPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData;
    const pastedData = clipboardData.getData('text/plain');
    const regex = /[0-9]/g;
  
    if (regex.test(pastedData)) {
      event.preventDefault(); 
    }
  }

  preparedAssignAccountantRequestObject(assignAccountants){
    let accountantArray = [];
    assignAccountants.forEach(id => {
      let accountantObj : any = {};
      accountantObj.accountantId = id;
      accountantArray.push(accountantObj);
    });
    return accountantArray;
  }
  
  updateUser(){
    this.userForm.value.id=this.editData.id;
    this.loading = true;
    this.userForm.value.roles = this.getRole(this.userForm.value.roles);

    if(this.selectedRole){
      this.userForm.value.roles = this.getRole(this.selectedRole);
    }
  
    let requestBody = this.prepareUserRequestBody(this.userForm.value);  
		this.auth.updateSuperAdminUser(requestBody).subscribe((res: any) => {
        if(res.status == "SUCCESS"){
          this.broadCast.sendMessage('getClientUsers');
          this.broadCast.sendMessage('accountant-dashboard'); 
          this.updateToaster=res.message;
          this.userId = res.data.id;
          if(res.data.roles[0].id == 4) {
            let activty = {
              activitySectorName : res.data.activitySector
            }
            this.auth.addActivitySector(activty,this.userId).subscribe(res => {
              if(res.status == 'SUCCESS') {
              }
            });
          }
          if(!this.isRole && !this.isAssignedAccountant){
            this.dialogRef.close(false);
          }
           if(this.isRole){
             this.updateRole();
           }
           if(this.isAssignedAccountant){
            this.assignAccountants(this.userForm.value.assignAccountants);
           }
           this.translate.get(['ACCOUNTANT.USERS.ADD_USER.UPDATE_SUCCESS'])
              .subscribe(translations => {
                this.updateToaster = translations['ACCOUNTANT.USERS.ADD_USER.UPDATE_SUCCESS'];
              });
           this.toastr.success(this.updateToaster,'');
	}else{
            this.toastr.error(res.message,'');
	 }
	 },(error) => {

  },() => {
    this.loading = false; 
  })	
  }

  prepareUserRequestBody(formValues) {
    try {
      return {
        ...formValues,
        active: this.editData.active,
        fullName: formValues.firstName + " " + formValues.lastName
      };
    } catch (error) {
      console.error("Error while preparing the request body, ", error);
    }
  }

  updateRole(){
    try {
        this.roleToUpdate = this.getRole(this.selectedRole);
        this.auth.updateUserRole(this.editData.id,this.roleToUpdate).subscribe((res: any) => {
            if(res.status == "SUCCESS"){
              this.toastr.success(res.message,'');
              this.dialogRef.close(false);
              this.broadCast.sendMessage('getClientUsers');
              this.broadCast.sendMessage('accountant-dashboard'); 
              }else{
                this.toastr.error(res.message,'');
              }
          })
    } catch (error) { 
    }
  }
  getAccountants() {
    try {
      let selectedOrganizationId = this.currentUser.organizationId;
      if (selectedOrganizationId !== "" && selectedOrganizationId !== null) {
        this.auth.getAccountants(selectedOrganizationId).subscribe((response) => {
          let accountantsWithoutCurrentUser = response.data.filter((accountant => accountant.id != this.editData.id));
          this.accountants = this.preparedAccountantData(accountantsWithoutCurrentUser);
        }, (err) => {
          console.log(err);
        });
      }
    } catch (exception) {
      console.error("Error ocurred while getting the accountants");
    }
  }

  preparedAccountantData(accountants){
    accountants.forEach(accountant => {
      let firstName = accountant?.firstName ? accountant?.firstName : accountant.accountant?.firstName;
      let lastName = accountant.lastName ? accountant.lastName : accountant.accountant.lastName;
      accountant.name = firstName + ' ' + lastName;
      accountant.accountantId = accountant.accountantId ? accountant.accountantId : accountant.id;
    });
    return accountants;
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  firstNameKeyPress(event: any){
    const pattern = /^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._\-\s]*$/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }


}

